unit ChargeItemListType;
{

/* Initial. */

}
interface

uses
  ChargeItemType;

type
  TChargeItemListType = array of TChargeItemType;

implementation

end.
